// ATENÇÃO: Sempre que um novo campo for adicionado
// set a propriedade visible para false
export default [
  {
    id: 'number',
    text: 'Número',
    title: 'Número do grupo, operador, cliente, ...',
    visible: true
  },
  {
    id: 'name',
    text: 'Nome',
    title: 'Nome do grupo, departamento, agente, etc.',
    visible: true
  },
  {
    id: 'initials',
    text: 'Sigla',
    title: 'Sigla do grupo de atendimento',
    visible: false
  },
  {
    id: 'members',
    text: 'Qtd. Membros',
    title: 'Quantidade de membros desse grupo',
    visible: true
  },
  {
    id: 'logged',
    text: 'Logados',
    title: 'Quantidade de operadores logados no grupo',
    visible: true
  },
  {
    id: 'available',
    text: 'Disponíveis',
    title: 'Quantidade de operadores disponíveis para atendimento no grupo',
    visible: true
  },
  {
    id: 'paused',
    text: 'Em Pausa',
    title: 'Quantidade de operadores em pausa no grupo',
    visible: true
  },
  {
    id: 'busy',
    text: 'Ocupados',
    title: 'Quantidade de operadores com ramal ocupado no grupo',
    visible: true
  },
  {
    id: 'internal',
    text: 'Internas',
    title:
      'Quantidade de ligações internas do operador, grupo, departamento, etc',
    visible: false
  },
  {
    id: 'pctInternal',
    text: '% Internas',
    title:
      'Percentual de ligações internas do operador, grupo, departamento, etc',
    visible: false
  },
  {
    id: 'received',
    text: 'Recebidas',
    title: 'Total de registros de recebimento (ligação)',
    visible: true
  },
  {
    id: 'directReceived',
    text: 'Recebidas Direto',
    title:
      'Chamadas recebidas diretamente por este destino sem transbordo, transferencia, captura, etc.',
    visible: false
  },
  {
    id: 'answering',
    text: 'Em Atendimento',
    title:
      'Total de ligações em atendimento agora. Porém, podem ter sido colocadas em espera no ramal neste momento',
    visible: false
  },
  {
    id: 'answered',
    text: 'Atendidas',
    title: 'Total de registros de atendimento (ligação)',
    visible: true
  },
  {
    id: 'realAnswering',
    text: 'Falando',
    title:
      'Ligações que estão em atendimento e em conversação (não está em espera no ramal)',
    visible: true
  },
  {
    id: 'answeredRecall',
    text: 'Atendidas Rechamada',
    title: 'Ligações atendidas depois de tentar transferir sem sucesso',
    visible: false
  },
  {
    id: 'answeredNormal',
    text: 'Atendidas Sem Captura',
    title: 'Ligações atendidas normalmente sem captura',
    visible: false
  },
  {
    id: 'answeredOverflow',
    text: 'Atendidas Pós-Transbordo',
    title:
      'Ligações atendidas após serem transbordadas. Caso tenha transbordado para outro grupo, Não contabiliza como atendimento para este grupo!',
    visible: false
  },
  {
    id: 'callPickup',
    text: 'Capturadas',
    title: 'Ligações atendidas por captura',
    visible: false
  },
  {
    id: 'pctAnswered',
    text: '% Atendidas',
    title: 'Percentual de registros de atendimento',
    visible: false
  },
  {
    id: 'ttanswer',
    text: 'T. atendimento(P)',
    title:
      'Tempo de atendimento deste operador, grupo, departamento, etc. No período',
    visible: false
  },
  {
    id: 'avganswer',
    text: 'TM. atendimento(P)',
    title:
      'Tempo médio de atendimento deste operador, grupo, departamento, etc. No período',
    visible: true
  },
  {
    id: 'maxanswer',
    text: 'Max. atendimento(P)',
    title:
      'Maior tempo de atendimento deste operador, grupo, departamento, etc. No período',
    visible: false
  },
  {
    id: 'minanswer',
    text: 'Min. atendimento(P)',
    title:
      'Menor tempo de atendimento deste operador, grupo, departamento, etc. No período',
    visible: false
  },
  {
    id: 'ttwait',
    text: 'T. Espera',
    title:
      'Soma dos tempos de espera deste operador, grupo, departamento, etc. No período',
    visible: false
  },
  {
    id: 'avgwait',
    text: 'TM. Espera',
    title: 'Tempo médio de espera deste grupo, departamento, etc. No período',
    visible: true
  },
  {
    id: 'maxwait',
    text: 'Max. Espera',
    title: 'Maior tempo de espera deste grupo, departamento, etc.',
    visible: false
  },
  {
    id: 'minwait',
    text: 'Min. Espera',
    title: 'Menor tempo de espera deste grupo, departamento, etc.',
    visible: false
  },
  {
    id: 'lost',
    text: 'Perdidas',
    title: 'Total de chamadas perdidas',
    visible: true
  },
  {
    id: 'pctLost',
    text: '% Perdidas',
    title: 'Percentual de chamadas perdidas',
    visible: false
  },
  {
    id: 'grpbusy',
    text: 'Grupo Ocupado',
    title:
      'chamadas que foram entregues ao grupo ocupado (não haviam agentes logados)',
    visible: false
  },
  {
    id: 'leaved',
    text: 'Abandonadas',
    title: 'Total de registros de abandono em fila',
    visible: true
  },
  {
    id: 'pctLeaved',
    text: '% Abandonadas',
    title: 'Percentual de registros de abandono em fila',
    visible: false
  },
  {
    id: 'notAnswered',
    text: 'Não Atendidas',
    title: 'Total de registros de não atendidas pelos operadores',
    visible: true
  },
  {
    id: 'notAnsweredAndOverflowed',
    text: 'Não Atd. e Transbordadas',
    title:
      'Total de chamadas que foram transbordadas pelo PABX após não serem atendidas pelos operadores',
    visible: false
  },
  {
    id: 'pctNotAnswered',
    text: '% Não Atendidas',
    title: 'Percentual de registros de não atendidas pelos operadores',
    visible: false
  },
  {
    id: 'queue',
    text: 'Fila',
    title: 'Ligações em fila agora',
    visible: true
  },
  {
    id: 'tqueue',
    text: 'T. Fila',
    title: 'Soma do tempo das ligações em fila agora',
    visible: false
  },
  {
    id: 'avgqueue',
    text: 'TM. Fila',
    title: 'Tempo médio das ligações em fila agora',
    visible: true
  },
  {
    id: 'maxqueue',
    text: 'Max. Fila',
    title: 'Ligação a mais tempo em fila agora',
    visible: false
  },
  {
    id: 'minqueue',
    text: 'Min. Fila',
    title: 'Ligação a menos tempo em fila agora',
    visible: false
  },
  {
    id: 'queued',
    text: 'Fila(P)',
    title: 'Total de ligações que passaram pela fila no dia',
    visible: false
  },
  {
    id: 'ttqueued',
    text: 'T. fila(P)',
    title: 'Soma do tempo de espera em fila no periodo',
    visible: false
  },
  {
    id: 'avgqueued',
    text: 'TM. fila(P)',
    title: 'Tempo médio de espera em fila no periodo',
    visible: false
  },
  {
    id: 'maxqueued',
    text: 'Max. fila(P)',
    title: 'Maior tempo de espera em fila no periodo',
    visible: false
  },
  {
    id: 'minqueued',
    text: 'Min. fila(P)',
    title: 'Menor tempo de espera em fila no periodo',
    visible: false
  },
  {
    id: 'hqueued',
    text: 'Maior Fila',
    title: 'Maior fila do periodo (ligações enfileiradas ao mesmo tempo)',
    visible: false
  },
  {
    id: 'thqueued',
    text: 'H:Maior Fila',
    title:
      'Momento em que ocorreu a maior fila do periodo (ligações enfileiradas ao mesmo tempo)',
    visible: false
  },
  {
    id: 'ringing',
    text: 'Ringando',
    title: 'Chamadas que estão tocando em ramal agora',
    visible: true
  },
  {
    id: 'tringing',
    text: 'T. Ring',
    title: 'Soma do tempo das chamadas que estão tocando em ramal agora',
    visible: false
  },
  {
    id: 'avgringing',
    text: 'TM. Ring',
    title: 'Tempo médio de chamadas que estão tocando em ramal agora',
    visible: false
  },
  {
    id: 'maxringing',
    text: 'Max. Ring',
    title: 'Chamada a mais tempo tocando em ramal agora',
    visible: false
  },
  {
    id: 'minringing',
    text: 'Min. Ring',
    title: 'Chamada a menos tempo tocando em ramal agora',
    visible: false
  },
  {
    id: 'ttring',
    text: 'T. ring(P)',
    title: 'Tempo de espera em ring deste operador, grupo, departamento, etc.',
    visible: false
  },
  {
    id: 'avgring',
    text: 'TM. ring(P)',
    title:
      'Tempo médio de espera em ring deste operador, grupo, departamento, etc.',
    visible: false
  },
  {
    id: 'maxring',
    text: 'Max. ring(P)',
    title:
      'Maior tempo de espera em ring deste operador, grupo, departamento, etc.',
    visible: false
  },
  {
    id: 'minring',
    text: 'Min. ring(P)',
    title:
      'Menor tempo de espera em ring deste operador, grupo, departamento, etc.',
    visible: false
  },
  {
    id: 'incoming',
    text: 'Entrada',
    title:
      'Quantidade de ligações que vieram de origem externa para o operador, grupo, departamento, etc',
    visible: false
  },
  {
    id: 'pctIncoming',
    text: '% Entrada',
    title:
      'Percentual de ligações que vieram de origem externa para este operador, grupo, departamento, etc',
    visible: false
  },
  {
    id: 'overflow',
    text: 'Rcb. Transbordo',
    title:
      'Ligações que foram transbordadas automáticamente (pelo PABX) para este operador, grupo, departamento, etc',
    visible: false
  },
  {
    id: 'overflowed',
    text: 'Transbordadas',
    title:
      'Ligações que foram transbordadas automaticamente (pelo PABX) deste este operador, grupo, departamento, etc. Para outro destino',
    visible: false
  },
  {
    id: 'transfer',
    text: 'Rcb. Transferência',
    title:
      'Ligações que foram transferidas para este operador, grupo, departamento, etc',
    visible: false
  },
  {
    id: 'transferred',
    text: 'Transferidas',
    title:
      'Ligações que foram transferidas por este operador, grupo, departamento, etc. Para outro destino',
    visible: false
  },
  {
    id: 'recalling',
    text: 'Rechamando',
    title: 'Chamadas que voltaram a tocar neste operador, grupo, etc. Agora',
    visible: false
  },
  {
    id: 'recall',
    text: 'Rechamadas',
    title:
      'Chamadas que voltaram a tocar neste operador, grupo, etc. Após espera ou transferencia (no período)',
    visible: false
  },
  {
    id: 'endByCalling',
    text: 'Fim Chamador',
    title: 'Chamadas que foram desligadas por quem originou a chamada',
    visible: false
  },
  {
    id: 'endByCalled',
    text: 'Fim Chamado',
    title: 'Chamadas que foram desligadas por quem recebeu a chamada',
    visible: false
  },
  {
    id: 'delivered',
    text: 'Entregues',
    title:
      'Chamadas que foram recebidas pelo destino final agente, cliente, etc.',
    visible: false
  },
  {
    id: 'consulting',
    text: 'Em Consulta',
    title: 'Chamadas colocadas em espera pelo operador, grupo, etc. agora',
    visible: false
  },
  {
    id: 'transferring',
    text: 'Em Transferência',
    title:
      'Chamadas que estão sendo transferidas deste operador, grupo, etc. agora',
    visible: false
  },
  {
    id: 'held',
    text: 'Flash',
    title:
      'Chamadas colocadas em espera (flash ou hold) pelo operador, grupo, etc.',
    visible: false
  },
  {
    id: 'helded',
    text: 'Consultas',
    title: 'Chamadas colocadas em espera pelo operador, grupo, etc. No período',
    visible: false
  },
  {
    id: 'tthelded',
    text: 'T. consulta(P)',
    title:
      'Tempo de consulta deste operador, grupo, departamento, etc. No período',
    visible: false
  },
  {
    id: 'avghelded',
    text: 'TM. consulta(P)',
    title:
      'Tempo médio de consulta deste operador, grupo, departamento, etc. No período',
    visible: false
  },
  {
    id: 'maxhelded',
    text: 'Max. consulta(P)',
    title:
      'Maior tempo de consulta deste operador, grupo, departamento, etc. No período',
    visible: false
  },
  {
    id: 'minhelded',
    text: 'Min. consulta(P)',
    title:
      'Menor tempo de consulta deste operador, grupo, departamento, etc. No período',
    visible: false
  },
  {
    id: 'conferencing',
    text: 'Em Conferência',
    title: 'Ligações em conferência no momento',
    visible: false
  },
  {
    id: 'scores',
    text: 'Chamadas Avaliadas',
    title: 'Quantidade de chamadas avalidas pelos clientes',
    visible: false
  },
  {
    id: 'score',
    text: 'Nota Total',
    title: 'Soma das notas de chamadas avalidas pelos clientes',
    visible: false
  },
  {
    id: 'avgscore',
    text: 'Nota Média',
    title: 'Média das notas recebidas',
    visible: false
  },
  {
    id: 'minscore',
    text: 'Menor Nota',
    title: 'Menor nota recebida',
    visible: false
  },
  {
    id: 'maxscore',
    text: 'Maior Nota',
    title: 'Maior nota recebida',
    visible: false
  }
];
